import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router'
import { inject } from '@angular/core'

/**
 * Las puertas viejas del asistente de carga, que ahora es un modal de Cobranza.
 *
 * `/cobranza/lote` y `/cobranza/lote/:uploadBatch` eran pantallas completas. Al pasar el asistente a
 * un modal, el lote viaja en `?carga=` — y `redirectTo` de Angular **no sabe escribir parámetros de
 * consulta**, solo rutas. Una guarda sí: devuelve un `UrlTree` y ahí cabe todo.
 *
 * Existe para que no se rompa nada de lo que ya está escrito: marcadores, la dirección que el
 * operador copió de un lote a medias, y los enlaces de los manuales. `:uploadBatch` se conserva, que
 * es lo único que de verdad importa de esas direcciones.
 */
export const abrirCargaDePagos = (route: ActivatedRouteSnapshot): UrlTree => {
	const router = inject(Router)
	const uploadBatch = route.paramMap.get('uploadBatch')

	return router.createUrlTree(['/cobranza/dinero'], { queryParams: { carga: uploadBatch || 'nuevo' } })
}
